import * as t from 'io-ts'
import { MultiLocaleString } from './multi-locale-string'

/**
 * Article IDs are stored as comma-separated list of IDs in a MLS.
 * After we load the data from the DB we split the strings and convert
 * into a map from Locale to list of IDs.
 */

export type ArticleIds = string[]

export const MultiLocaleArticleIds = t.record(t.string, t.array(t.string))
export type MultiLocaleArticleIds = t.TypeOf<typeof MultiLocaleArticleIds>

export function parseMultiLocaleArticleIds(mls: MultiLocaleString): MultiLocaleArticleIds {
  const articleIds: { [k: string]: string[] } = {}

  for (const k in mls) {
    const s = mls[k]
    if (s) {
      const ids = s
        .split(',')
        .map((x) => x.trim())
        .filter((x) => x !== '')

      if (ids.length > 0) {
        articleIds[k] = ids
      }
    }
  }

  return articleIds
}
